import React, { createContext, useState } from "react";

export const HighlightContext = createContext();

export const HighlightProvider = ({ children }) => {
  const [acceptReject, setAcceptReject] = useState({
    accept: false,
    reject: false,
  });

  return (
    <HighlightContext.Provider value={{ acceptReject, setAcceptReject }}>
      {children}
    </HighlightContext.Provider>
  );
};
